import { EventEmitter, createEventEmitter } from './EventEmitter';
import Deferred from './DeferredUtil';

export const UtilFactory = {
  createEventEmitter(obj?: any): EventEmitter {
    return createEventEmitter(obj);
  },
  Deferred: Deferred,
};
